import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';

const ExerciseCard = ({ exercise }) => {
  return (
    <>
      <Link className="exercise-card" to={`/exercise/${exercise.id}`}>
        <img src={exercise.gifUrl} alt={exercise.name} loading="lazy" />

        <Stack direction="row">
          <Button
            variant="contained"
            color="error"
            sx={{
              ml: '21px',
              color: '#fff',
              background: '#FA2625',
              fontSize: '14px',
              borderRadius: '20px',
              texttransform: 'capitalize',
            }}
          >
            {exercise.bodyPart}
          </Button>
          <Button
            className="btnBlack"
            variant="contained"
            sx={{
              ml: '21px',
              color: '#fff',
              background: '#111',
              fontSize: '14px',
              borderRadius: '20px',
              texttransform: 'capitalize',
            }}
          >
            {exercise.target}
          </Button>
        </Stack>

        <Typography
          ml="21px"
          color="#000"
          fontWeight="bold"
          mt="11px"
          pb="10px"
          texttransform="capitalize"
          fontSize="22px"
        >
          {exercise.name}
        </Typography>
      </Link>
    </>
  );
};

export default ExerciseCard;
